function middlewareFactory(errorHandler) {
  return function (store) {
    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          errorHandler(err, store.getState, action, store.dispatch);
          return err;
        }
      };
    };
  };
}

module.exports = middlewareFactory;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-catch/index.js
// module id = 1045
// module chunks = 9